import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { HeaderService } from "./../http/header.service";

@Injectable()
export class ValidadoresService {
  constructor(private http: Http, private HeaderService: HeaderService) {}

  validarEmailNoGX(email: string): any {
    const headers = this.HeaderService.getHeadersGnx();

    return this.http
      .post(
        environment.apiGxUrl + "/wsveremail.svc/rest/",
        {
          Email: email,
          Hab_List: "N",
          Val_Dom: "S",
        },
        { headers: headers }
      )
      .map((res) => res.json())
      .catch((err: any) => {
        return Observable.throw(new Error(err.json()));
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/validadores/validadores.service.ts